export default function DOM_Traversing() {
  return (
    <div>
      <h1>DOM_Traversing</h1>
      <p>This is the DOM_Traversing component.</p>
    </div>
  );
}